import { Box } from "@mui/material";
import React, { ReactNode } from "react";
import { EventWrapperProps } from "react-big-calendar";

import { clsxc } from "@/common/clsxc";

import { GenericCalendarEntry } from "../Calendar";

interface Props<TEntry extends GenericCalendarEntry> extends Partial<EventWrapperProps<TEntry>> {
  children?: ReactNode;
}

export function RBCEventWrapperCustom<TEntry extends GenericCalendarEntry>(props: Props<TEntry>) {
  const { event } = props;
  const start = event?.start ? event.start : new Date();
  const end = event?.end ? event.end : new Date();
  const durationMinutes = (end.getTime() - start.getTime()) / 60000;
  const isShort = durationMinutes < 30;

  let children = props.children;
  if (isShort && React.isValidElement(children)) {
    const element = children as React.ReactElement<any>;
    children = React.cloneElement(element, {
      children: React.Children.map(element.props.children, (child: any) => {
        if (
          React.isValidElement(child) &&
          child.props &&
          typeof child.props === "object" &&
          "className" in child.props &&
          typeof child.props.className === "string" &&
          child.props.className &&
          child.props.className.includes("rbc-event-label")
        ) {
          return null;
        }
        return child;
      }),
    });
  }

  return (
    <Box
      component='div'
      className={clsxc(props.className, "rbc-event-wrapper-custom")}
      style={props.style}
    >
      {children}
    </Box>
  );
}
